import { graphql } from '~/graphql/generated/gql';

export const adminConsiderationAreaListFragment = graphql(`
  fragment AdminConsiderationAreaListFields on AdminConsiderationArea {
    id
    label
    slug
    industryId
    industry {
      id
      name
    }
    parentId
    parent {
      id
      label
    }
  }
`);

export const adminConsiderationAreaList = graphql(`
  query adminConsiderationAreaList($page: Int!, $first: Int!, $filters: AdminConsiderationAreaFilters) {
    considerationAreas(page: $page, first: $first, filters: $filters) {
      data {
        ...AdminConsiderationAreaListFields
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const considerationAreaFragment = graphql(`
  fragment ConsiderationAreaFields on ConsiderationArea {
    id
    label
    slug
    color
    industryId
    industry {
      id
      name
      slug
    }
    iconFileId
    iconFile {
      id
      publicUrl
    }
    userLevel
    userProgressPercentage 
  }
`);

export const adminConsiderationAreaManagementFragment = graphql(`
  fragment AdminConsiderationAreaManagementFields on AdminConsiderationArea {
    id
    label
    color
    industryId
    parentId
    iconFileId
    industry {
      id
      name
    }
    parent {
      id
      label
    }
    iconFile {
      ...AdminContentFileFields
    }
    partnerId
    partner {
      id
      name
    }
  }
`);

export const fetchConsiderationAreas = graphql(`
  query fetchConsiderationAreas {
    allConsiderationAreas {
      ...ConsiderationAreaFields
    }
  }
`);

export const adminConsiderationAreaFilterOptions = graphql(`
  query adminConsiderationAreaFilterOptions {
    considerationAreasList(filters: { includeChildren: true }) {
      id
      label
    }
  }
`);

export const adminConsiderationAreaParentOptions = graphql(`
  query adminConsiderationAreaParentOptions {
    considerationAreasList {
      id
      label
      industryId
    }
  }
`);

export const createConsiderationAreaMutation = graphql(`
  mutation createConsiderationArea($input: CreateConsiderationAreaInput!) {
    createConsiderationArea(input: $input) {
      considerationArea {
        ...AdminConsiderationAreaManagementFields
      }
    }
  }
`);

export const updateConsiderationAreaMutation = graphql(`
  mutation updateConsiderationArea($input: UpdateConsiderationAreaInput!) {
    updateConsiderationArea(input: $input) {
      considerationArea {
        ...AdminConsiderationAreaManagementFields
      }
    }
  }
`);

export const deleteConsiderationAreaMutation = graphql(`
  mutation deleteConsiderationArea($input: DeleteConsiderationAreaInput!) {
    deleteConsiderationArea(input: $input) {
      success
    }
  }
`);

export const getAdminConsiderationArea = graphql(`
  query getAdminConsiderationArea($id: ID!) {
    considerationAreas(page: 1, first: 1, filters: { ids: [$id], includeChildren: true }) {
      data {
        ...AdminConsiderationAreaManagementFields
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const fetchHubLiveExpo = graphql(`
  query fetchHubLiveExpo($considerationAreaSlug: String!) {
    hubLiveExpo(considerationAreaSlug: $considerationAreaSlug) {
      id
      learningCampaigns {
        ...UnifiedLearningCampaignFields
      }
    }
  }
`);

export const fetchLiveExpos = graphql(`
  query fetchLiveExpos {
    liveExpos {
      id
      considerationAreaSlug
      considerationAreaLabel
      learningCampaigns {
        ...UnifiedLearningCampaignFields
      }
    }
  }
`);
